// Keep normal reveal timing; make content readable if observer setup is unavailable.
export function createRevealObserver(
  callback: IntersectionObserverCallback,
  options?: IntersectionObserverInit
): Pick<IntersectionObserver, 'observe' | 'disconnect'> {
  if (typeof document !== 'undefined') {
    document.documentElement.classList.add('reveal-ready');
  }
  const reveal = (target: Element) => {
    // Recover every section, including any not registered with an observer.
    if (typeof document !== 'undefined') {
      document.documentElement.classList.add('reveal-fallback');
    }
    if (target.matches('.scroll-fade')) target.classList.add('visible');
    target.querySelectorAll('.scroll-fade').forEach((el) => el.classList.add('visible'));
  };
  const fallback = { observe: reveal, disconnect: () => {} };
  if (typeof IntersectionObserver === 'undefined') return fallback;
  try {
    const observer = new IntersectionObserver(callback, options);
    return {
      observe(target) {
        try {
          observer.observe(target);
        } catch {
          reveal(target);
        }
      },
      disconnect: () => observer.disconnect(),
    };
  } catch {
    return fallback;
  }
}
